import * as types from '../action-types';
import { MoreLikeThisReducerType } from '../decisionState.types';
import { MoreLikeThisActions } from '../actions';

const initialState: MoreLikeThisReducerType = {
  isOpen: false,
  isFetching: false,
  referenceDecisions: [],
  similarDecisions: [],
  tooLongError: false,
  isMoreLikeThisMenuShown: false,
  moreLikeThisMenuText: '',
};

export function moreLikeThisReducer(
  state: MoreLikeThisReducerType = initialState,
  action: MoreLikeThisActions,
) {
  switch (action.type) {
    case types.openMoreLikeThisModal: {
      return {
        ...state,
        isOpen: true,
      };
    }
    case types.closeMoreLikeThisModal: {
      return { ...state, isOpen: false };
    }
    case types.fetchingMoreLikeThisDecisions: {
      return { ...state, isFetching: true, tooLongError: false };
    }
    case types.storeMoreLikeThisDecisions: {
      const { similarDecisions, referenceDecisions } = action.payload;
      return { ...state, similarDecisions, referenceDecisions };
    }
    case types.storeSelectionTooLongError: {
      return { ...state, tooLongError: true };
    }
    case types.fetchEndMoreLikeThisDecisions: {
      return { ...state, isFetching: false };
    }
    case types.errorServer: {
      return {
        ...state,
        similarDecisions: [],
        referenceDecisions: [],
      };
    }
    case types.showMoreLikeThisMenu: {
      return {
        ...state,
        isMoreLikeThisMenuShown: action.payload,
      };
    }
    case types.storeMoreLikeThisMenuText: {
      return { ...state, moreLikeThisMenuText: action.payload };
    }
    default: {
      return state;
    }
  }
}
